import React from "react";
import "./ProductoContador.css";
import icono from "../../../../../assets/img/icons/shop-car.svg";

export default function ProductoContador({ cantidad = 0 }) {
  return (
    <div className="producto-contador">
      <img
        src={icono || ".."}  // ruta por defecto o prop
        alt="icono producto"
        className="icono-cantidad"
      />
      <span className="badge-cantidad">{cantidad}</span>
    </div>
  );
}
